import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/icon_image_discard.svg'
import _imports_1 from '@/assets/images/icon_image_plus.svg'


const _hoisted_1 = { class: "star-pop" }
const _hoisted_2 = { class: "star-pop__input_container" }
const _hoisted_3 = { class: "star-pop__star_input" }
const _hoisted_4 = { class: "star-pop__comment_input" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "star-pop__star-image-container" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onClick"]

import { ref } from 'vue';
import { createReview } from '@/api/review';
import StarInput from './StarInput.vue';
import { $t } from '@/plugins/translation';
import { projectStore } from '@/stores/project';

import { uploadFileToProject } from '@/api/file';


export default /*@__PURE__*/_defineComponent({
  __name: 'StarPost',
  props: {
  memberIdx: {
    type: Number,
    default: null,
  },
},
  setup(__props, { expose: __expose }) {

const imageListSrc = ref<File[]>([]);
const blankCount = ref(3 - imageListSrc.value.length);
const props = __props;

const moduleProject = projectStore();

const formReview = ref({
  content: '',
  rating: 1,
  medias: [],
});
const handleUploadClick = () => {
  const fileInput = document.getElementById(`fileInput`);
  if (fileInput) {
    fileInput.click();
  }
};

const uploadImage = async (event: Event) => {
  const files = (event.target as HTMLInputElement).files;
  if (files && files.length > 0) {
    const file = files[0];
    const reader = new FileReader();
    reader.onload = async () => {
      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await uploadFileToProject(
          moduleProject.selectedProjectId as number,
          formData,
        );
        console.log(response);
        formReview.value.medias.push(response.data.fileIdx);
      } catch (e) {
        console.error('Error uploading file:', e);
      }
    };
    reader.readAsDataURL(file);
    imageListSrc.value.push(files[0]);
    blankCount.value = blankCount.value - 1;
  }
};

const handleCreateReview = async () => {
  try {
    const response = await createReview({ memberIdx: props.memberIdx || 1, ...formReview.value });
    console.log(response);
  } catch (error) {
    console.error(error);
  }
};

const discardImage = (index: number) => {
  formReview.value.medias.splice(index, 1);
  imageListSrc.value.splice(index, 1);
  blankCount.value = blankCount.value + 1;
};

const createObjectURL = (file: File | null) => {
  if (!file) return require('@/assets/images/image_star_rate_sample.png');
  return URL.createObjectURL(file);
};

__expose({
  handleCreateReview,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(StarInput, {
          modelValue: formReview.value.rating,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formReview.value.rating) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formReview.value.content) = $event)),
          placeholder: _unref($t)('component.starPost', 'placeholder')
        }, null, 8, _hoisted_5), [
          [_vModelText, formReview.value.content]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageListSrc.value, (imagesrc, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "star-pop__star-image",
            key: index,
            alt: "image"
          }, [
            _createElementVNode("img", {
              class: "star-pop__star-image-box",
              src: createObjectURL(imagesrc)
            }, null, 8, _hoisted_7),
            _createElementVNode("img", {
              class: "star-pop__star-discard-icon",
              src: _imports_0,
              onClick: ($event: any) => (discardImage(index))
            }, null, 8, _hoisted_8)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blankCount.value, (x) => {
          return (_openBlock(), _createElementBlock("div", { key: x }, [
            _createElementVNode("div", {
              class: "star-pop__star-blank-box",
              onClick: handleUploadClick
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                class: "star-pop__star-blank-icon",
                src: _imports_1
              }, null, -1)
            ])),
            _createElementVNode("input", {
              type: "file",
              id: "fileInput",
              accept: "image/*",
              hidden: "",
              onChange: uploadImage
            }, null, 32)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})